;(function () {
  'use strict'

  angular
    .module('admin.email_management.service', [])
    .factory('EmailManagementService', EmailManagementService)

  /** @ngInject */
  function EmailManagementService($http, $q, API) {
    function list(start, limit, notification_type, option, days, startDate, endDate, expor, fields) {
      var defered = $q.defer()
      var endpoint = expor ? 'admin/users/emails/export' : 'admin/users/emails'
      
      var params = {
        notification_type: notification_type,
        option: option,
        days: days,
        'start-date': startDate,
        'end-date': endDate,
      }

      if (expor) {
        if (fields) {
          params.fields = fields
        }
      } else {
        params.start = start
        params.limit = limit
      }

      $http
        .get(`${API.API_URL}${endpoint}`, { params: params })
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function upload(body) {
      var defered = $q.defer()

      $http.post(`${API.API_URL}admin/users/no_bounces`, body).success(defered.resolve)

      return defered.promise
    }

    return {
      list,
      upload,
    }
  }
})()
